import React from 'react';
import { createRoot } from 'react-dom/client';

import { trySession } from '@lib/Session';
import { App as BaseApp } from '@components/App';
import { withSnackbar } from '@components/App/_snackbar';
import { withTheme } from '@components/App/_theme';
import { useClientContext } from '@lib/useClientContext';

import './reset.css';

const App = (
    withTheme(
        withSnackbar(BaseApp),
    )
);

(async() => {
    Telegram.WebApp.enableClosingConfirmation();

    const rootProps = await trySession();

    const rootNode = document.querySelector('#root');

    if (!rootNode) return;

    const root = createRoot(rootNode);

    useClientContext.setState({
        uuid: rootProps.uuid,
        user: rootProps.user,
        apiRequest: rootProps.apiRequest,
    });

    root.render(<App />);
})();
